import { createAction } from '@reduxjs/toolkit'
import { RootState } from './createStore'

export const hydrate = createAction<RootState>('root/hydrate')
